<template>
  <div>
    <div class="drafts oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="listData"
        :rowKey="(record) => record.id"
      >
        <div slot="order" slot-scope="text, record, index">{{index+1}}</div>
        <div slot="action">
          <a-button type="link" class="btn-link" @click="add()">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link"> 删除 </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :size="size"
          :total="total"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'order',
    key: 'order',
    width: 80,
    scopedSlots: { customRender: "order" }
  },
  {
    title: '部门/单位名称',
    dataIndex: 'departmentName',
    key: 'departmentName'
  },
  {
    title: '收款人',
    dataIndex: 'collectionName',
    key: 'collectionName'
  },
  {
    title: '收款单位名称',
    dataIndex: 'collectionCompanyName',
    key: 'collectionCompanyName',
    ellipsis: true
  },
  {
    title: '合计金额（元）',
    dataIndex: 'totalFee',
    key: 'totalFee',
    ellipsis: true
  },
  {
    title: '申请日期',
    dataIndex: 'applyTime',
    key: 'applyTime'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]

import { expenseReimbursementDraftList } from './api/api'
export default {
  data() {
    return {
      listData: [],
      columns,
      page: 1,
      size: '10',
      total: 0
    }
  },
  created() {
    this.expenseReimbursementDraftListFn()
  },
  methods: {
    add() {
      this.$router.push('/addClaimExpense')
    },
    pageChange(pageNumber) {
      console.log('Page: ', pageNumber)
      this.page = pageNumber
      this.expenseReimbursementDraftListFn()
    },
    // 列表
    expenseReimbursementDraftListFn() {
      const params = {
        page: this.page,
        size: this.size
      }
      expenseReimbursementDraftList(params).then((res) => {
        console.log('草稿箱列表', res)
        if (res.status == 200) {
          this.listData = res.data.data.records
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    pageChange(page) {
      this.page = page
      this.expenseReimbursementDraftListFn()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ClaimExpense/drafts.vue